import React, { createContext, ReactNode, useCallback, useState } from 'react';

export type GeoLocationProps = {
  latitude: number;
  longitude: number;
};

export type GeoLocationContextProps = {
  latitude: number;
  longitude: number;
  handleGetCurrentGeoLocation: () => void;
};

export type GeoLocationProviderProps = {
  children: ReactNode;
};

export const GeoLocationContext = createContext({} as GeoLocationContextProps);

export const GeoLocationProvider = ({ children }: GeoLocationProviderProps) => {
  const [geoLocation, setGeoLocation] = useState<GeoLocationProps>(
    {} as GeoLocationProps
  );

  const handleGetCurrentGeoLocation = useCallback(() => {
    navigator.geolocation.getCurrentPosition(async (position) => {
      const { latitude, longitude } = position.coords;
      setGeoLocation({
        latitude,
        longitude,
      });
    });
  }, []);

  return (
    <GeoLocationContext.Provider
      value={{ ...geoLocation, handleGetCurrentGeoLocation }}
    >
      {children}
    </GeoLocationContext.Provider>
  );
};
